import {
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  Typography,
  makeStyles
} from '@material-ui/core';
import DrawerList from 'components/DrawerList';
import SearchField from 'components/SearchField';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { neutralNr20, textPrimary } from 'common/colors';
import * as actions from '../../store/actions';
import { connect } from 'react-redux';
import Input from 'components/Input';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  formItem: {
    labelWidth: 0,
    '& .MuiOutlinedInput-root': { borderRadius: '8px' }
  }
});

const DrawerInfoList = ({
  isOpen,
  setIsOpen,
  data,
  listTitle,
  setSelectedValue,
  selectedValue,
  handleFetchTeritory,
  handleFetchWorkingField,
  id,
  searchable,
  searchPlaceHolder,
  loanAmount,
  interestLoanInstallmentMin,
  interestLoanInstallmentMax,
  isOpenOtherPurpose,
  setIsOpenOtherPurpose,
  setLoanPurpose,
  setTenure,
  setIsCompanyUpdated,
  withoutOther,
  isUserLoyalty,
  serverSide = false,
  onServerSearch = () => {},
  onLoadMore = null,
  hasMore = false,
  isLoadingMore = false,
  showEmpty = false,
  emptyText = 'Data tidak ditemukan'
}) => {
  const classes = useStyles();

  const [originalDataList, setOriginalDataList] = React.useState([]);
  const [dataList, setDataList] = React.useState([]);

  const inputProperty = {
    otherLoanPurpose: {
      className: classes.formItem,
      id: 'otherLoanPurpose',
      placeholder: 'Masukkan alasan kamu',
      valid: false,
      style: { backgroundColor: neutralNr20, color: textPrimary },
      inputProps: {
        required: true,
        maxLength: 50
      },
      fullWidth: true
    }
  };

  React.useEffect(() => {
    setOriginalDataList(data || []);
    setDataList(data || []);
  }, [data]);

  // Infinite scroll
  const handlePaperScroll = e => {
    if (!onLoadMore || !hasMore || isLoadingMore) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - scrollTop - clientHeight < 80) {
      onLoadMore();
    }
  };

  const handleCloseDrawer = () => {
    setIsOpen(false);
    setTimeout(() => {
      setDataList(data);
    }, 2000);
  };

  const handleChangeValue = text => {
    const isValidField = field => id === field && field in selectedValue;

    const fieldHandlers = {
      fieldOfWork: prev => ({
        ...prev,
        [id]: text.value,
        fieldOfWorkDesc: text.label
      }),

      fieldOfBusiness: prev => ({
        ...prev,
        [id]: text.value,
        fieldOfBusinessDesc: text.label,
        fieldOfSubBusinessDesc: ''
      }),

      fieldOfSubBusiness: prev => ({
        ...prev,
        [id]: text.value,
        fieldOfSubBusinessDesc: text.label
      }),

      jobTitle: prev => ({
        ...prev,
        [id]: text.key,
        jobTitleDesc: text.value
      }),

      dailyNormalTransactions: prev => ({
        ...prev,
        [id]: text.key,
        dailyNormalTransactionsDesc: text.value
      }),

      provinceOfWork: prev => ({
        ...prev,
        [id]: text.value,
        provinceOfWorkDesc: text.label
      }),

      cityOfWork: prev => ({
        ...prev,
        [id]: text.value,
        cityOfWorkDesc: text.label
      }),

      districtOfWork: prev => ({
        ...prev,
        [id]: text.value,
        districtOfWorkDesc: text.label
      }),

      wardOfWork: prev => ({
        ...prev,
        [id]: text.value,
        wardOfWorkDesc: text.label
      }),

      companyName: prev => {
        setIsCompanyUpdated('Y');

        return {
          ...prev,
          [id]: text.value,
          companyName2: ''
        };
      },

      tenure: prev => ({
        ...prev,
        [id]: text.value,
        tenureDesc: text.label
      }),

      loanPurpose: prev => {
        if (text.value === 'LNN') {
          setIsOpenOtherPurpose(true);

          return {
            ...prev,
            [id]: ''
          };
        }

        return {
          ...prev,
          [id]: text.label
        };
      },

      education: prev => ({
        ...prev,
        [id]: text.value,
        educationDesc: text.label
      }),

      religion: prev => ({
        ...prev,
        [id]: text.value
      }),

      desa: prev => ({
        ...prev,
        [id]: text.value,
        postalCode: text.postalCode
      }),

      desaKtp: prev => ({
        ...prev,
        [id]: text.value,
        postalCodeKtp: text.postalCode
      }),

      placeOfBirth: prev => ({
        ...prev,
        [id]: text.label,
        placeOfBirthCode: text.value
      })
    };

    setSelectedValue(prev => {
      const handler = fieldHandlers[id];

      if (handler && isValidField(id)) {
        return handler(prev);
      }

      return {
        ...prev,
        [id]: text.value
      };
    });

    if (isValidField('tenure')) setTenure(text.value);
    if (isValidField('loanPurpose')) setLoanPurpose(text.value);

    handleFetchTeritory && handleFetchTeritory(id, text.value);
    handleFetchWorkingField && handleFetchWorkingField(id, text.value);

    /**
     * handle close drawer after choose the data
     */
    if (isValidField('loanPurpose') && text.value === 'LNN') return;
    else handleCloseDrawer();
  };

  const handleBackChooseOtherPurpose = () => {
    setIsOpenOtherPurpose(false);
    setSelectedValue(prev => {
      return {
        ...prev,
        [id]: ''
      };
    });
    setLoanPurpose('');
  };

  const listDrawer = () => {
    const drawerListData = serverSide || !searchable ? data : dataList;

    return (
      <div
        style={{
          backgroundColor: 'white',
          padding: '8px 16px 40px 16px'
        }}
      >
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            style={{
              fontFamily: 'Lato',
              fontWeight: 700,
              fontSize: '18px',
              marginTop: id === 'tenure' ? '16px' : '0px'
            }}
          >
            {listTitle}
            {id === 'tenure' && (
              <Typography>
                {isUserLoyalty === 'Y'
                  ? 'termasuk bunga flat 1.5%'
                  : 'termasuk bunga flat 1.50% - 2.00%'}
              </Typography>
            )}
          </Typography>

          <IconButton
            onClick={() => {
              handleCloseDrawer();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {searchable ? (
          <SearchField
            dataList={originalDataList}
            onServerSearch={onServerSearch}
            placeholder={searchPlaceHolder}
            resetKey={isOpen}
            serverSide={serverSide}
            setDataList={setDataList}
            withoutOther={withoutOther}
          />
        ) : null}
        <DrawerList
          data={drawerListData}
          emptyText={emptyText}
          handleChangeValue={handleChangeValue}
          id={id}
          interestLoanInstallmentMax={interestLoanInstallmentMax}
          interestLoanInstallmentMin={interestLoanInstallmentMin}
          isLoadingMore={isLoadingMore}
          isUserLoyalty={isUserLoyalty}
          loanAmount={loanAmount}
          showEmpty={showEmpty}
        />
      </div>
    );
  };

  const chooseOtherPurpose = () => {
    return (
      <>
        <Grid container direction="column" wrap="nowrap">
          <Grid
            alignItems="center"
            container
            direction="row"
            item
            wrap="nowrap"
          >
            <Grid item>
              <IconButton onClick={handleBackChooseOtherPurpose}>
                <ArrowBackIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography color="textPrimary" variant="subtitle1">
                Lainnya
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container direction="column" style={{ padding: '16px' }}>
          <Grid item style={{ marginBottom: '16px' }}>
            <Typography variant="body1">
              Alasan lainnya kamu ajukan pinjaman.
            </Typography>
          </Grid>
          <Grid item style={{ marginBottom: '24px' }}>
            <Input
              {...inputProperty.otherLoanPurpose}
              label="Masukkan Tujuan Pinjaman Lainnya"
              onChange={e => {
                setSelectedValue(prev => {
                  return {
                    ...prev,
                    [id]: e.target.value
                  };
                });
              }}
              value={selectedValue?.loanPurpose}
            />
          </Grid>
          <Grid item>
            <Button
              color="secondary"
              disabled={
                selectedValue?.loanPurpose.length < 3 ||
                selectedValue?.loanPurpose.length > 50
              }
              fullWidth
              onClick={() => {
                handleCloseDrawer();
                setLoanPurpose(selectedValue?.loanPurpose);
              }}
              variant="contained"
            >
              Lanjutkan
            </Button>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <div>
      <Drawer
        PaperProps={{
          elevation: 0,
          onScroll: handlePaperScroll,
          style: {
            maxWidth: '500px',
            maxHeight: 'calc(100% - 24px)',
            margin: '0 auto',
            borderRadius: '16px 16px 0px 0px',
            height: 'auto'
          }
        }}
        anchor="bottom"
        open={isOpen}
      >
        {!isOpenOtherPurpose ? listDrawer() : chooseOtherPurpose()}
      </Drawer>
    </div>
  );
};

DrawerInfoList.propTypes = {
  data: PropTypes.array,
  emptyText: PropTypes.string,
  handleFetchTeritory: PropTypes.func,
  handleFetchWorkingField: PropTypes.func,
  hasMore: PropTypes.bool,
  id: PropTypes.string,
  interestLoanInstallmentMax: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  interestLoanInstallmentMin: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  isLoadingMore: PropTypes.bool,
  isOpen: PropTypes.bool,
  isOpenOtherPurpose: PropTypes.bool,
  isUserLoyalty: PropTypes.string,
  listTitle: PropTypes.node,
  loanAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onLoadMore: PropTypes.func,
  onServerSearch: PropTypes.func,
  searchPlaceHolder: PropTypes.string,
  searchable: PropTypes.bool,
  selectedValue: PropTypes.object,
  serverSide: PropTypes.bool,
  setIsCompanyUpdated: PropTypes.func,
  setIsOpen: PropTypes.func,
  setIsOpenOtherPurpose: PropTypes.func,
  setLoanPurpose: PropTypes.func,
  setSelectedValue: PropTypes.func,
  setTenure: PropTypes.func,
  showEmpty: PropTypes.bool,
  withoutOther: PropTypes.bool
};

const mapDispatchToProps = dispatch => {
  return {
    setLoanPurpose: val => {
      dispatch(actions.setLoanPurpose(val));
    },
    setTenure: val => {
      dispatch(actions.setTenure(val));
    },
    setIsCompanyUpdated: value => {
      dispatch(actions.setIsCompanyUpdated(value));
    }
  };
};

export default connect(null, mapDispatchToProps)(DrawerInfoList);
